import axios from '../axios';
import * as types from './types';
import { createTypes } from './createTypes';
import { setMsgInfo } from './msgInfo';
import API from './api';
import filterError from './common/filterError';
// import { getQueryParams } from './common/getQueryParams';

const baseUrl = API + '/organisation-function-proposal';

export const addOrgFunctionProposal = (payload) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(`${baseUrl}/`, payload);
      dispatch({
        type: createTypes(types.ADD_ORG_FUNCTION_PROPOSAL).success,
        payload: data,
      });
      // dispatch(
      //   setMsgInfo({
      //     success: true,
      //     msg: ['Org Function proposal added successfully'],
      //     navigationCounter: 2,
      //   }),
      // );
      return data;
    } catch (err) {
      const errors = filterError(err);
      dispatch({
        type: createTypes(types.ADD_ORG_FUNCTION_PROPOSAL).failure,
        payload: errors,
      });
      dispatch(
        setMsgInfo({
          success: false,
          msg: errors,
        }),
      );
    }
  };
};

// NOTE: getRegisterInstituteOptions, getSchoolOptions, getMedicalFacilityOptions,
// getCreditCardOptions, getBankOptions, and deleteOrgFunctionAssignment were removed
// from this file to resolve webpack 5 conflicting star exports with orgFunctionAssignment.js.
// These functions are available via orgFunctionAssignment.js (imported first in actions/index.js).

export const addBulkOrgFunctionProposal = (payload) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(`${baseUrl}/bulk_create/`, payload);
      // dispatch(
      //   setMsgInfo({
      //     success: true,
      //     msg: ['Org Function proposal added successfully'],
      //     navigationCounter: 2,
      //   }),
      // );
      return data;
    } catch (err) {
      const errors = filterError(err);
      dispatch(
        setMsgInfo({
          success: false,
          msg: errors,
        }),
      );
    }
  };
};


// NOTE: The following exports were removed to resolve webpack 5 conflicting star exports
// with orgFunctionAssignment.js (imported first in actions/index.js):
// - getRegisterInstituteOptions (available via orgFunctionAssignment.js)
// - getSchoolOptions (available via orgFunctionAssignment.js)
// - getMedicalFacilityOptions (available via orgFunctionAssignment.js)
// - getCreditCardOptions (available via orgFunctionAssignment.js)
// - getBankOptions (available via orgFunctionAssignment.js)
// - deleteOrgFunctionAssignment (available via orgFunctionAssignment.js)

